import { useState, useEffect } from 'react';
import { TriangleAlert } from 'lucide-react';
import { DataTable, LoadingSpinner } from '@shared/components';
import styles from './DataPage.module.css';


function DataPage({
  title,
  fetchData,
  columns,
  columnFilters = [],
  onDrawerButtonAction = {},
  actionLabel = '',
  includeMap = false,
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const result = await fetchData();
        if (active) setData(result);
      } catch (err) {
        if (active) setError(err.message || "Error");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => (active = false);
  }, [fetchData, columnFilters]);

  if (loading) {
    return (
      <div className={styles.container}>
        <span>Loading...</span>
        <LoadingSpinner color="black" />
      </div>
    );
  }
  if (error) {
    return (
      <div className={styles.container}>
        <TriangleAlert color="var(--color-deep)" />
        <span>Error: {error}</span>
      </div>
    );
  }

  return (
    <>
      {/* <h1 className={styles.pageHeading}>{title}</h1> */}
      <DataTable
        data={data}
        columns={columns}
        columnFilters={columnFilters}
        onDrawerButtonAction={onDrawerButtonAction}
        actionLabel={actionLabel}
        includeMap={includeMap}
      />
    </>
  );
}

export default DataPage;